import React, { FC, useContext, useState } from 'react';

import { Paper } from '@material-ui/core';
import { navigate } from '@reach/router';

import { GlobalContext } from '../../../../../../store';

import Button from '../../../../../../components/Button';
import Modal from '../../../../../../components/Modal';
import { useRouteInfoState } from '../../../../../../components/RouteInfo/Context/RouteInfo.context';

const DeleteClub: FC = () => {
  const {
    actions,
    actions: {
      notifications: { pushSuccess, pushError }
    }
  } = useContext(GlobalContext);

  const { clubId } = useRouteInfoState();

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const modalToggle = (): void => setModalIsOpen(!modalIsOpen);

  const onDeleteClub = async () => {
    const response = await actions.adminClubs.delete(clubId);

    if (response && response.errors) {
      modalToggle();

      await pushError(response.errors.adminClubs.msg);
    } else {
      modalToggle();
      await navigate('/staff/home');

      pushSuccess('The club has been deleted');
    }
  };

  return (
    <Paper elevation={1} className="paper">
      <div>
        <div className="header-card-container">
          <div>
            <span className="header-title">DELETE THIS CLUB</span>
          </div>
        </div>

        <p className="about-text delete-text">
          If you delete this club all information will be lost and unrecoverable. Please be certain
          before you delete this club. If you’d like to no longer be the administrator of this club
          you can transfer that role to another officer in the officers tab above. But if you must,
          click DELETE CLUB, then confirm.
        </p>

        <div className="club-delete-main-container">
          <div className="button-container">
            <Button
              id="delete-club-button"
              onClick={modalToggle}
              variant="outlined"
              color="primary"
              className="button show-modal-button"
            >
              DELETE CLUB
            </Button>
          </div>

          <Modal
            className="modal-club-delete"
            id="club15-help-modal"
            open={modalIsOpen}
            onClose={modalToggle}
            text="Are you sure you want to delete this club?"
            title="Delete this club"
            actions={[
              <Button
                onClick={modalToggle}
                variant="outlined"
                color="primary"
                fullWidth={true}
                className="button submit"
                key="button-cancel"
              >
                CANCEL
              </Button>,
              <Button
                id="confirm-delete-club-button"
                onClick={onDeleteClub}
                variant="contained"
                color="primary"
                fullWidth={true}
                className="button button-shadow submit delete-club-button"
                key="button-delete"
              >
                DELETE
              </Button>
            ]}
          />
        </div>
      </div>
    </Paper>
  );
};

export default DeleteClub;
